import { HttpErrorResponse } from '@angular/common/http';
import { createFeature, createReducer, on } from '@ngrx/store';
import { ContractConfirmation } from '../entities/contract-confirmation.entity';
import { contractConfirmationActions, contractConfirmationApiActions } from './contract-confirmation.actions';

export const CONTRACT_CONFIRMATION_FEATURE_KEY = 'contract-confirmation';

interface ContractConfirmationState {
  error: HttpErrorResponse | null;
  contractConfirmations: ContractConfirmation[];
  hasAccepted: boolean;
  loading: boolean;
}

const initialState: ContractConfirmationState = {
  error: null,
  contractConfirmations: [],
  hasAccepted: false,
  loading: false,
};

export const contractConfirmationFeature = createFeature({
  name: CONTRACT_CONFIRMATION_FEATURE_KEY,
  reducer: createReducer(
    initialState,
    on(
      contractConfirmationActions.loadRequiredContractConfirmations,
      (state): ContractConfirmationState => ({ ...state, error: null, hasAccepted: false, loading: true }),
    ),
    on(
      contractConfirmationApiActions.loadRequiredContractConfirmationsSuccess,
      (state, { contractConfirmations }): ContractConfirmationState => ({
        ...state,
        contractConfirmations,
        loading: false,
      }),
    ),
    on(
      contractConfirmationApiActions.loadRequiredContractConfirmationsFailure,
      (state, { error }): ContractConfirmationState => ({ ...state, error, loading: false }),
    ),
    on(contractConfirmationActions.acceptContracts, (state): ContractConfirmationState => ({ ...state, error: null, loading: true })),
    on(
      contractConfirmationApiActions.acceptContractsSuccess,
      (state): ContractConfirmationState => ({
        ...state,
        hasAccepted: true,
        contractConfirmations: [],
        loading: false,
      }),
    ),
    on(
      contractConfirmationApiActions.acceptContractsFailure,
      (state, { error }): ContractConfirmationState => ({ ...state, error, loading: false }),
    ),
  ),
});
